/**
 * Placeholder Content Utility
 * 
 * This module provides reusable placeholder content for sections that are
 * temporarily under construction or coming soon.
 */

const placeholderContent = {
  /**
   * Generate "Coming Soon" placeholder content
   * @returns {string} HTML content for the placeholder
   */
  comingSoon: function() {
    return `
      <div class="h-full w-full absolute inset-0 flex items-center justify-center">
        <div class="text-center">
          <h2 class="text-2xl font-bold text-gray-800 mb-4">Content Coming Soon</h2>
          <p class="text-gray-600">We're currently updating this section with new information.</p>
        </div>
      </div>
    `;
  },
  
  /**
   * Renders the placeholder content in the specified container
   * @param {string} containerId - ID of the HTML element to render content into
   */
  render: function(containerId) {
    const container = document.getElementById(containerId);
    if (!container) {
      console.error(`Container with ID "${containerId}" not found`);
      return;
    }
    
    container.innerHTML = this.comingSoon();
  }
};

// Make available globally
window.placeholderContent = placeholderContent;